<script lang="ts">
  import { afterUpdate, onMount } from "svelte";
  import Spinner from "./Spinner.svelte";
  import { help, pageCount } from "./stores";
  import { image_index, post_index } from "./images.json";
  import ImageNavLinks from "./ImageNavLinks.svelte";
  import Tip from "./help/Tip.svelte";

  export let shortcode;
  let prevShortcode = shortcode;

  $: image = image_index[shortcode];
  $: post = post_index[image.parent_shortcode];
  $: createdAt = new Date(post.created_at * 1000);

  let el;
  let loading = true;

  afterUpdate(() => {
    if (prevShortcode !== shortcode) {
      loading = true;
      prevShortcode = shortcode;
    }
  });

  onMount(() => {
    const pid = el.addEventListener("load", () => (loading = false));
    return () => pid && el.removeEventListener(pid);
  });
</script>

<figure>
  <div class="image">
    <div class="mouse-help">
      <Tip>if prefer using the mouse 🐭, you can click pages to navigate</Tip>
    </div>

    <img
      bind:this={el}
      src="__IMAGES_BASE__/{image.shortcode}.jpg"
      alt={image.caption} />

    {#if loading}
      <div class="spinner">
        <Spinner />
      </div>
    {/if}

    {#if $pageCount}
      <span class="page-count">
        {$pageCount}
      </span>
    {:else if $help}
      <span class="page-count"> 1/3 </span>
    {/if}
    <ImageNavLinks />

    <div class="pages-help">
      <Tip>hint: a post can have many pages &UpperRightArrow;</Tip>
    </div>
  </div>
  <figcaption>
    <p class="description">{post.description}</p>
    <p class="caption">{image.caption}</p>
    <time datetime={createdAt.toISOString()}>
      @ {createdAt.toLocaleString([], {
        year: "numeric",
        month: "short",
        day: "numeric",
      })}
    </time>
  </figcaption>
</figure>

<style>
  .spinner {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  figure {
    margin: 0;
    display: flex;
    flex-direction: column;
    margin-bottom: 1px;
  }

  figure img {
    object-fit: contain;
    object-position: bottom;
    max-height: 75vh;
  }

  div.image {
    position: relative;
  }

  div.mouse-help {
    position: absolute;
    top: 50%;
    left: 1rem;
    right: 1rem;
    display: flex;
    justify-content: center;
    max-width: calc(100% - 2rem);
  }

  div.pages-help {
    position: absolute;
    margin-top: 0.25rem;
    right: 0;
  }

  figure span.page-count {
    position: absolute;
    bottom: 0;
    right: 0;
    font-weight: bold;
    padding: 0.25rem 0.5rem;
    margin: 2px 1px 0 2px;
    color: #faf9f9;
    background-color: rgba(0, 0, 0, 0.5);
  }

  figcaption {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-end;
  }

  figcaption time {
    font-weight: bold;
    color: #999;
    padding: 0.25rem;
  }

  figcaption p {
    padding: 0.25rem;
    margin: 0;
    background-color: #eee;
  }

  figcaption p.description {
    margin-top: 1px;
  }
  figcaption p.caption {
    margin-top: 1px;
  }

  @media (min-width: 400px) {
    figure {
      flex-direction: row !important;
      max-height: 75vh;
    }

    figure img {
      max-width: 60vw;
      margin-right: 1px;
    }

    figcaption {
      align-items: flex-start !important;
      align-self: start;
      max-width: 50vw;
    }
  }
</style>
